import * as React from "react";
const SvgExit = (props) => (
  <svg
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.167 11.333 4.833 8m0 0 3.334-3.333M4.833 8H16.5m-4.167 3.333v.834a2.5 2.5 0 0 1-2.5 2.5H4a2.5 2.5 0 0 1-2.5-2.5V3.833a2.5 2.5 0 0 1 2.5-2.5h5.833a2.5 2.5 0 0 1 2.5 2.5v.834"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgExit;
